import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;
export const BACKEND_ORIGIN = BACKEND_URL;

const TOKEN_KEY = "veerox_token";
const USER_KEY = "veerox_user";
// Phase 8A — impersonation token is stored SEPARATELY from the admin's own
// token so we can revert to the admin session with a single click.
const IMPERSONATION_TOKEN_KEY = "veerox_impersonation_token";
const IMPERSONATION_META_KEY  = "veerox_impersonation_meta";  // {target, impersonator, exp}

export const getToken = () => (
  localStorage.getItem(IMPERSONATION_TOKEN_KEY) || localStorage.getItem(TOKEN_KEY)
);
export const getAdminToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(IMPERSONATION_TOKEN_KEY);
  localStorage.removeItem(IMPERSONATION_META_KEY);
};

// Impersonation helpers
export const startImpersonation = (token, meta) => {
  localStorage.setItem(IMPERSONATION_TOKEN_KEY, token);
  localStorage.setItem(IMPERSONATION_META_KEY, JSON.stringify(meta || {}));
};
export const stopImpersonation = () => {
  localStorage.removeItem(IMPERSONATION_TOKEN_KEY);
  localStorage.removeItem(IMPERSONATION_META_KEY);
};
export const isImpersonating = () => !!localStorage.getItem(IMPERSONATION_TOKEN_KEY);
export const getImpersonationMeta = () => {
  try { return JSON.parse(localStorage.getItem(IMPERSONATION_META_KEY) || "null"); }
  catch { return null; }
};
export const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY) || "null");
  } catch {
    return null;
  }
};
export const setStoredUser = (u) => localStorage.setItem(USER_KEY, JSON.stringify(u));

export const api = axios.create({ baseURL: API_BASE });

// List of endpoints where auto-injecting account_id would be wrong or redundant.
// Anything else that has an ?account_id= param will get one from localStorage.
const ACCOUNT_ID_SKIP = [
  /^\/auth\//,
  /^\/accounts(\/|$)/,
  /^\/brokers(\/|$)/,
  /^\/ea\//,        // EA endpoints authenticate by ea_api_key already
  /^\/ws\b/,
  /^\/news\b/,
];

const ACCOUNT_STORAGE_KEY = "veerox_active_account_id";

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;

  // Auto-inject account_id query param when appropriate
  const url = config.url || "";
  const path = url.split("?")[0];
  const shouldSkip = ACCOUNT_ID_SKIP.some((rx) => rx.test(path));
  if (!shouldSkip) {
    const accountId = localStorage.getItem(ACCOUNT_STORAGE_KEY);
    if (accountId) {
      config.params = { account_id: accountId, ...(config.params || {}) };
    }
  }
  return config;
});

api.interceptors.response.use(
  (resp) => resp,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (path !== "/login" && path !== "/register") {
        clearToken();
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const wsUrl = (token) => {
  if (!BACKEND_URL) return "";
  const u = new URL(BACKEND_URL);
  const proto = u.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${u.host}/api/ws?token=${encodeURIComponent(token)}`;
};
